import { createApp } from 'vue'
import Vant from 'vant'
import { showToast } from 'vant'
import App from './App.vue'
import * as ww from '@wecom/jssdk';
import router from './router';
import store from './store';
import 'vant/lib/index.css'
import { initAppState } from '@/utils/auth';

// 初始化应用状态
initAppState();

const app = createApp(App);

app.use(store);
app.use(Vant);
app.use(router);
app.config.globalProperties.$toast = showToast
app.config.globalProperties.$ww = ww;
app.mount('#app')
